export default __webpack_public_path__ + "static/media/bullet.27b3781e.svg";